<template>
  <div class="resignation">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row align-items-center">
              <div class="col">
                <h3 class="page-title">My Team Expense/Reimbursement Claim</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item">
                    <router-link to="/index">Dashboard</router-link>
                  </li>
                  <li class="breadcrumb-item active">
                    Expense/Reimbursement Claim
                  </li>
                </ul>
              </div>
              <div class="col-auto float-right ml-auto">
                <!-- <router-link
                  to="/add-expense"
                  class="btn add-btn"
                  ><i class="fa fa-plus"></i> Add Expense Claim</router-link
                > -->
              </div>
            </div>
          </div>
          <!-- /Page Header -->
          <!----Datatable-->
          <div class="row">
            <div class="col-md-12">
              <div class="table-responsive">
                <v-data-table
                  :headers="headers"
                  :items="sortedExpenseClaim"
                  sort-by=""
                  class="elevation-1"
                >
                  <template v-slot:[`item.actions`]="{ item }">
                    <div class="dropdown dropdown-action">
                      <a
                        href="#"
                        class="action-icon dropdown-toggle"
                        data-toggle="dropdown"
                        aria-expanded="false"
                        ><i class="material-icons">more_vert</i></a
                      >
                      <div class="dropdown-menu dropdown-menu-right">
                        <router-link
                          :to="{
                            name: 'editExpense2',
                            params: { id: item.id }
                          }"
                          class="dropdown-item"
                          ><i class="fa fa-pencil m-r-5"></i> View</router-link
                        >
                        <a
                          class="dropdown-item"
                          @click="openDialogStatus(item)"
                          v-if="
                            item.status == 0 &&
                              item.nextApproval == user.employee.id
                          "
                          ><i class="fa fa-check"></i> Approve or Reject</a
                        >
                      </div>
                    </div>
                  </template>

                  <template v-slot:[`item.date`]="{ item }">
                    {{
                      item.date
                        ? new Date(item.date).toLocaleDateString()
                        : item.date
                    }}
                  </template>
                  <template v-slot:[`item.remark`]="{ item }">
                    {{
                      item.remark ? item.remark.substring(0, 25) : ''
                    }}
                  </template>
                  <template v-slot:[`item.profile`]="{ item }">
                    <h2 class="table-avatar blue-link">
                      <router-link to="/profile" class="avatar"
                        ><img alt="" src="~@/assets/profiles/avatar-02.jpg"
                      /></router-link>
                      <router-link to="/profile">{{
                        `${item.assigneeEmployee.firstName} ${item.assigneeEmployee.lastName}`
                      }}</router-link>
                    </h2>
                  </template>
                  <template v-slot:[`item.status`]="{ item }">
                    <a
                      class="btn btn-white btn-sm btn-rounded"
                      v-if="item.status == 0 && item.nextApproval"
                      aria-expanded="false"
                    >
                      <i class="fa fa-dot-circle-o text-purple"></i> Awaiting
                      Manager Approval
                    </a>
                    <a
                      class="btn btn-white btn-sm btn-rounded"
                      v-if="item.status == 7"
                      aria-expanded="false"
                    >
                      <i class="fa fa-dot-circle-o text-success"></i> Awaiting
                      Submission
                    </a>
                    <a
                      class="btn btn-white btn-sm btn-rounded"
                      v-if="item.status == 1 && (item.amount == item.approvedAmount  || item.approvedAmount == 0)"
                      aria-expanded="false"
                    >
                      <i class="fa fa-dot-circle-o text-success"></i> Approved
                    </a>
                    <a
                      class="btn btn-white btn-sm btn-rounded"
                      v-if="item.status == 1 && (item.amount != item.approvedAmount && item.approvedAmount > 0)"
                      aria-expanded="false"
                    >
                      <i class="fa fa-dot-circle-o text-success"></i> Approved But Awaiting Adjustment
                    </a>
                    <a
                      class="btn btn-white btn-sm btn-rounded"
                      v-if="item.status == 3"
                      aria-expanded="false"
                    >
                      <i class="fa fa-dot-circle-o text-success"></i> Completed
                    </a>
                    <a
                      class="btn btn-white btn-sm btn-rounded"
                      v-if="item.status == 2"
                      aria-expanded="false"
                    >
                      <i class="fa fa-dot-circle-o text-danger"></i> Declined
                    </a>
                  </template>
                </v-data-table>
              </div>
            </div>
          </div>
          <!---/Datatable-->
        </div>
        <!-- /Page Content -->

        <!-- Delete Resignation Modal -->
        <v-dialog v-model="dialogDelete" max-width="725px">
          <div class="modal-content">
            <div class="modal-body">
              <div class="form-header">
                <h3>Delete Expense/Reimbursement Claim</h3>
                <p>Are you sure want to delete?</p>
              </div>
              <div class="modal-btn delete-action">
                <div class="row">
                  <div class="col-6">
                    <a
                      @click.prevent="deleteExpenseClaim"
                      class="btn btn-primary continue-btn"
                      data-dismiss="modal"
                      >Delete</a
                    >
                  </div>
                  <div class="col-6">
                    <a
                      href="javascript:void(0);"
                      data-dismiss="modal"
                      class="btn btn-primary cancel-btn"
                      >Cancel</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-dialog>
        <!-- /Delete Resignation Modal -->
        <!-- Approve Leave Modal -->
        <v-dialog v-model="dialogStatus" max-width="500px">
          <div class="modal-content">
            <div class="modal-body">
              <div class="form-header">
                <button type="button" class="close" @click="closeDialogStatus">
                  <span aria-hidden="true">&times;</span>
                </button>
                <h3>Expense/Reimbursement Claim Approve</h3>
                <p>Are you sure want to approve for this claim?</p>
              </div>
              <div class="modal-btn delete-action">
                <div class="row">
                  <div class="col-6">
                    <a
                      @click="changeExpenseStatus(1)"
                      class="btn btn-primary continue-btn"
                      >Approve</a
                    >
                  </div>
                  <div class="col-6">
                    <a
                      @click="changeExpenseStatus(2)"
                      data-dismiss="modal"
                      class="btn btn-primary cancel-btn"
                      >Decline</a
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-dialog>
        <!-- /Approve Leave Modal -->
      </div>
      <!-- /Page Wrapper -->
    </div>
  </div>
</template>
<script>
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";
import { required, sameAs } from "vuelidate/lib/validators";
import { employeeService } from "@/services/employeeService.js";
import Datepicker from "vuejs-datepicker";
import { authenticationService } from "@/services/authenticationService";

export default {
  components: {
    LayoutHeader,
    LayoutSidebar,
    Datepicker
  },

  data() {
    return {
      dialogDelete: false,
      dialogStatus: false,
      headers: [
        {
          text: "Employee",
          align: "start",
          value: "profile"
        },
        { text: "Remark", value: "remark" },
        // { text: 'Reason', value: 'reason' },
        { text: "Amount", value: "amount" },
        { text: "Date", value: "date" },
        { text: "Status", value: "status" },
        { text: "", value: "actions", sortable: false }
      ],
      name: "",
      employeeId: "",
      remark: "",
      amount: "",
      assignee: "",
      assigneeId: "",
      expenseTypeId: 0,
      date: "",
      // resignationDate: "",
      // resignation: {},
      expenses: [],
      expenseTypes: [],
      expense: {},
      employee: [],
      loading: false,
      isManager: false,
      error: "",
      employees: [],
      submitted: false,
      user: authenticationService.currentUserValue,
      company: authenticationService.currentOfficeValue,
      file: null,
      fileName: null
    };
  },

  validations: {
    name: { required },
    reason: { required },
    date: { required },
    assignee: { required }
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
    dialogDelete(val) {
      val || this.closeDelete();
    },
    dialogEdit(val) {
      val || this.closeEdit();
    },
    dialogStatus(val) {
      val || this.closeDialogStatus();
    }
  },
  computed: {
    sortedExpenseClaim: function() {
      function compare(a, b) {
        if (new Date(a.date).getTime() < new Date(b.date).getTime()) return 1;
        if (new Date(a.date).getTime() > new Date(b.date).getTime()) return -1;
        return 0;
      }

      return this.expenses ? this.expenses.sort(compare) : this.expenses;
    }
  },
  methods: {
    clearModel() {
      this.date = "";
      this.remark = "";
      this.amount = "";
      this.assigneeId = "";
      this.file = null;
      this.fileName = null;
    },
    isEmployeeManager() {
      employeeService.isEmployeeManager().then(model => {
        this.isManager = model;
      });
    },
    onFilePicked(event) {
      const files = event.target.files;
      this.fileName = files[0].name;
      //   // console.log(this.fileName)
      // const fileReader = new FileReader()
      // fileReader.addEventListener('load', () => {
      // 	this.file = fileReader.result
      // })
      // fileReader.readAsDataURL(files[0])
      this.file = files[0];
    },

    changeFile() {
      this.file = null;
      this.fileName = "";
    },

    getEmployees() {
      const companyId = this.company.id;
      //console.log('this.company.id', this.company.id)
      employeeService.getEmployees(companyId).then(
        model => {
          this.employees = model;
          // console.log(model)
        },
        error => {
          error = error;
        }
      );
    },
    getTypes() {
      const companyId = this.company.id;
      //console.log('this.company.id', this.company.id)
      employeeService.getExpenseType(companyId).then(
        model => {
          this.expenseTypes = model;
          // console.log(model)
        },
        error => {
          error = error;
        }
      );
    },
    changeExpenseStatus(status) {
      this.submitted = true;
      this.expense.status = status;

      var req = { expenseClaimId: this.expense.id, approvalEmployeeId: this.user.employee.id, approvedDate: new Date(), approved: (status === 1) ? true : false}
      this.loading = true;
      employeeService.approveExpenseClaim(req).then(
        id => {
          var id = this.user.employee.id;
          employeeService.getExpenseClaimByTeam(id).then(model => {
            console.log(model);
            this.expenses = model;
            this.closeDialogStatus();
          });
        },
        error => {
          this.error = error;
          this.loading = false;
        }
      );
    },

    getExpenseClaim() {
      var id = this.user.employee.id;
      employeeService.getExpenseClaimByTeam(id).then(
        model => {
          console.log(model);
          this.expenses = model;
        },
        error => {
          error = error;
        }
      );
    },
    //   var userId = this.user.employee.id
    //   employeeService.getExpenseClaimByEmployee(userId).then(
    //     (model) => {
    //       console.log(model)
    //       this.expenses = model;
    //     },
    //     (error) => {
    //       error = error;
    //     }
    //   )
    // },
    openDialog() {
      this.dialog = true;
    },
    openDialogStatus(item) {
      this.expense = item;
      this.dialogStatus = true;
    },
    close() {
      this.dialog = false;
      this.clearModel();
    },
    closeDialogStatus() {
      this.dialogStatus = false;
      this.clearModel();
    },
    closeEdit() {
      this.dialogEdit = false;
      this.clearModel();
    },
    closeDelete() {
      this.dialogDelete = false;
    },
    setEditExpense(model) {
      this.expense = model;
      var Name = model.document.split("/");
      this.fileName = Name.length > 0 ? Name[Name.length - 1] : null;
      this.dialogEdit = true;
    },
    setDeleteExpense(model) {
      this.expense = model;
      this.dialogDelete = true;
    },
    deleteExpenseClaim() {
      this.loading = true;
      const id = this.expense.id;
      employee.removeExpenseClaim(id).then(
        id => {
          var id = this.user.employee.id;
          employeeService.getExpenseClaimByTeam(id).then(w => {
            (this.expenses = w), console.log(w);
            this.closeDelete();
          });
        },
        e => {
          this.error = e;
          this.loading = false;
          this.closeDelete();
        }
      );
    }
  },

  mounted() {
    this.isEmployeeManager();
    this.getExpenseClaim();
    this.getEmployees();
    this.getTypes();

    if ($(".datatable").length > 0) {
      $(".datatable").DataTable({
        bFilter: false
      });
    }
    // Date Time Picker

    if ($(".datetimepicker").length > 0) {
      $(".datetimepicker").datetimepicker({
        format: "DD/MM/YYYY",
        icons: {
          up: "fa fa-angle-up",
          down: "fa fa-angle-down",
          next: "fa fa-angle-right",
          previous: "fa fa-angle-left"
        }
      });
    }

    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function(e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "expensereports"
};
</script>



// WEBPACK FOOTER //
// src/components/expenses/Expense/listForManagerHR.vue